import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TermoContaComplementar } from '../models/termoContaComplementar.model';

export class TermoContaComplementarService extends ApiService implements BaseService<TermoContaComplementar>{

    private strAction = 'api/WebTempContaComplementar';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<TermoContaComplementar[]> {
        return this.get<TermoContaComplementar[]>(this.strAction + `/GetAll`);
    }

    deleteById(id: number) {
        return this.post(this.strAction + `/DeleteById?id=${id}`);
    }

    getById(id: number): Observable<TermoContaComplementar> {
        return this.get(this.strAction + `/GetById/${id}`);
    }

    getByCpf(cpf : string): Observable<TermoContaComplementar[]> {
        return this.get<TermoContaComplementar[]>(this.strAction + `/GetByCpf?nrCpf=${cpf}`);
    }

    Put(TermoContaComplementar: TermoContaComplementar): Observable<TermoContaComplementar> {
        return this.post<TermoContaComplementar>(this.strAction + `/Put`, TermoContaComplementar);
    }

}